import { fetchDataPromise } from '../index';

export const getDeviceList = (resolve, reject, token, account, selectSite) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/initdevicelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      account: account,
      selectSiteData: selectSite
    })
  });

  fetchDataPromise(req, 'getDeviceVapInfo', resolve, reject);
}

export const editDeviceTemplate = (resolve, reject, token, deviceSeq, ethernetSeq, templateSeq) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['device'] + '/editdevicemanager', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      },
      body: JSON.stringify({
        deviceSeq : deviceSeq,
        ethernetSeq : ethernetSeq,
        templateSeq : templateSeq
      })
    });

    fetchDataPromise(req, 'editDeviceTemplate', resolve, reject);
}

export const saveAbnormalStatusData = (resolve, reject, updAbnormalData, token) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['device'] + '/saveabnormalstatus', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Authorization' : token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updAbnormalData)
    });

    fetchDataPromise(req, 'saveabnormalstatus', resolve, reject)
}

export const dlDeviceControl = (resolve, reject, userManagerInfo, publishContent, target, deviceManagerInfo) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER_MQTT['mqtt'] + window.CONFIG.SWS_SERVER_MQTT['publish'] + '/dlDevice', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : userManagerInfo.authToken,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      publishContent: JSON.stringify(publishContent),
      target: target,
      userManagerInfo: JSON.stringify(userManagerInfo),
      deviceManagerInfo: JSON.stringify(deviceManagerInfo)
    })
  });

  fetchDataPromise(req, 'dlDeviceControl', resolve, reject);
}

export const getDeviceCAData = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['device'] + '/getdevicecalist', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getdevicecalist', resolve, reject);
}

export const triggerFirmwareUpgrade = (resolve, reject, token, firmwareUpgradeBody) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/upgradefirmware', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(firmwareUpgradeBody)
  });

  fetchDataPromise(req, 'triggerFirmwareUpgrade', resolve, reject);
}

export const getDeviceInfoByMac = (resolve, reject, token, mac) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getdeviceinfo?mac=' + mac, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
  });

  fetchDataPromise(req, 'getdeviceinfo', resolve, reject);
}

export const getDeviceInfo = (resolve, reject, token, data) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getdevicelistdetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(data)
  });

  fetchDataPromise(req, 'getdevicelistdetail', resolve, reject);
}

export const getDeviceNetInfo = (resolve, reject, token, device) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getdevicenetinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(device)
  });

  fetchDataPromise(req, 'getDeviceNetInfo', resolve, reject);
}

export const getDeviceRadioInfo = (resolve, reject, token, device) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getdeviceradioinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(device)
  });

  fetchDataPromise(req, 'getDeviceRadioInfo', resolve, reject);
}

export const getDeviceVapInfo = (resolve, reject, token, device) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getdevicevapinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(device)
  });

  fetchDataPromise(req, 'getDeviceVapInfo', resolve, reject);
}

export const getProfileNetInfo = (resolve, reject, token, model) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['profile'] + '/getnetlist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      model : model
    })
  });

  fetchDataPromise(req, 'getProfileNetInfo', resolve, reject);
}

export const getProfileRadioInfo = (resolve, reject, token, model) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['profile'] + '/getradiolist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      model : model
    })
  });

  fetchDataPromise(req, 'getProfileRadioInfo', resolve, reject);
}

export const getProfileVapInfo = (resolve, reject, token, model) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['profile'] + '/getvaplist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      model : model
    })
  });

  fetchDataPromise(req, 'getProfileVapInfo', resolve, reject);
}

export const getReadyToAddDeviceList = (resolve, reject, accountInfo, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/deviceapgetreadytoaddlist?account='+accountInfo.account, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'deviceapgetreadytoaddlist', resolve, reject);
}

export const readyToAddDevice = (resolve, reject, token, account, readyToAddParam) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/deviceapreadytoadd?account='+account+'&serverIp='+readyToAddParam.serverIp+'&changePassword='+readyToAddParam.changePassword;
  let req = new Request(requestURL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(readyToAddParam.addList)
  });

  fetchDataPromise(req, 'deviceapreadytoadd', resolve, reject);
}

export const assignGroupForDevice = (resolve, reject, token, groupId, deviceMacList) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/asigndevicegroup', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      groupId: groupId,
      deviceMacList: deviceMacList
    })
  });

  fetchDataPromise(req, 'asigndevicegroup', resolve, reject);
}

export const setupUseProfile = (resolve, reject, usedProfileFlag, mac, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/setupuseprofile', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      usedProfileFlag: usedProfileFlag,
      mac: mac
    })
  });

  fetchDataPromise(req, 'setupUseProfile', resolve, reject);
}

export const deleteDeviceDataInPrismX = (resolve, reject, deviceMac, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/devicedelinprismx?deviceMac=' + deviceMac;
  let req = new Request(requestURL, {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Authorization' : token,
          'Content-Type': 'application/json'
      }
  });

  fetchDataPromise(req, 'devicedelinprismx', resolve, reject)
}

export const getFirmwareUpgradeDeviceList = (resolve, reject, token, selectSite) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/getupgradedevicelist?site='+selectSite, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getUpgradeDeviceList', resolve, reject);
}

export const scanReadyToAddAP = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/scanreadytoaddap', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'scanreadytoaddap', resolve, reject);
}

export const getProfileRadioSettingInfo = (resolve, reject, token, model, country) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['profile'] + '/getprofilesettingradio', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      model : model,
      country: country
    })
  });

  fetchDataPromise(req, 'getprofilesettingradio', resolve, reject);
}

export const getMacWhiteList = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["deviceAp"] + '/manage/getdevicemacwhitelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({})
  });

  fetchDataPromise(req, 'getMacWhiteList', resolve, reject);
}

export const updateMacWhiteList = (resolve, reject, token, ids) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["deviceAp"] + '/manage/updatedevicemacwhitelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      ids
    })
  });

  fetchDataPromise(req, 'updateMacWhiteList', resolve, reject);
}

export const checkIsExistInMacWhiteList = (resolve, reject, mac) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["deviceAp"] + '/manage/checkisexistinmacwhitelist' , {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      mac: mac
    })
  });
  fetchDataPromise(req, 'checkIsExistInMacWhiteList', resolve, reject);
}

export const addAPToController = (resolve, reject, token, readyToAddParam, siteId) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/manage/deviceapjoin?siteId='+siteId;
  let req = new Request(requestURL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(readyToAddParam.addList)
  });

  fetchDataPromise(req, 'deviceapjoin', resolve, reject);
}

export const siteSurvey = (resolve, reject, token, objBody, radio, intcont) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/dlsitesurvey', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },

    body: JSON.stringify({
      mac: objBody.mac,
      model: objBody.model,
      cmd: "set_survey",
      reload: true,
      data: {
        radio: radio,
		    intcont: intcont
      }    
    })

  });
  fetchDataPromise(req, 'doSiteSurvey', resolve, reject);
}

export const dlConfigure = (resolve, reject, apiName, token, dlJson) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/manage/' + apiName, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(dlJson)
  });

  fetchDataPromise(req, apiName, resolve, reject);
}

export const dlreboot = (resolve, reject, token, dlJson) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/manage/dlreboot', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(dlJson)
  });

  fetchDataPromise(req, 'dlreboot', resolve, reject);
}

export const getPortNeighborInfo = (resolve, reject, token, mswitch) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['switch'] + '/getportneighborinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(mswitch)
  });

  fetchDataPromise(req, 'getportneighborinfo', resolve, reject);
}

export const editSwitchInfo = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['switch'] + '/editswitch', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'editswitch', resolve, reject);
}

export const triggerDeviceInfo = (resolve, reject, token, apMac, siteId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['deviceAp'] + '/triggerinfo?' + (apMac ? ('mac=' + apMac) : ('siteId=' + siteId)), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization': token,
      'Content-Type': 'application/json'
    },
  });
  fetchDataPromise(req, 'triggerinfo', resolve, reject);
}